import ProductBoost from './ProductBoost.vue';

export const productBoostRoutes = [
  { path: 'product-boost', component: ProductBoost, name: 'product-boost' }
];
